document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var burger = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Show cart icon / count only once cart has items or after first add
  var cartIcon = document.querySelector('[data-cart-icon]');
  if (cartIcon) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          cartIcon.style.display = 'inline-flex';
        }
      })
      .catch(function () {});
  }

  // Only allow a single FAQ item open at a time
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      }
    });
  });

  // Simple light/dark toggle (adds a class to <html>; theme ships dark by default)
  var themeToggle = document.querySelector('[data-theme-toggle]');
  if (themeToggle) {
    themeToggle.addEventListener('click', function () {
      document.documentElement.classList.toggle('is-light');
    });
  }

  // Video modal (Watch the curriculum, course lesson previews, etc.)
  var videoModal = document.getElementById('VideoModal');
  var videoFrame = document.getElementById('VideoModalFrame');
  var lastFocusedEl = null;

  function buildEmbed(type, src, fileUrl, title) {
    var safeTitle = title || 'Video';
    if (type === 'file' && fileUrl) {
      return '<video controls autoplay playsinline style="width:100%;height:100%;" src="' + fileUrl + '"></video>';
    }
    if (type === 'vimeo' && src) {
      var vimeoId = (src.match(/vimeo\.com\/(?:video\/)?(\d+)/) || [])[1];
      if (vimeoId) {
        return '<iframe src="https://player.vimeo.com/video/' + vimeoId + '?autoplay=1" title="' + safeTitle + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="width:100%;height:100%;border:0;"></iframe>';
      }
    }
    if (src) {
      var ytId = (src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/) || [])[1];
      if (ytId) {
        return '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0" title="' + safeTitle + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="width:100%;height:100%;border:0;"></iframe>';
      }
    }
    return '<p style="color:#93a29c;padding:2rem;text-align:center;">Add a video URL or upload a video file to this block in the theme editor to enable playback.</p>';
  }

  function openVideoModal(trigger) {
    if (!videoModal || !videoFrame) return;
    var type = trigger.getAttribute('data-video-type') || 'youtube';
    var src = trigger.getAttribute('data-video-src') || '';
    var fileUrl = trigger.getAttribute('data-video-file-url') || '';
    var title = trigger.getAttribute('data-video-title') || '';
    videoFrame.innerHTML = buildEmbed(type, src, fileUrl, title);
    videoModal.hidden = false;
    document.body.style.overflow = 'hidden';
    lastFocusedEl = trigger;
    var closeBtn = videoModal.querySelector('.video-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeVideoModal() {
    if (!videoModal || !videoFrame) return;
    videoModal.hidden = true;
    videoFrame.innerHTML = '';
    document.body.style.overflow = '';
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  document.querySelectorAll('[data-video-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openVideoModal(trigger);
    });
  });

  document.querySelectorAll('[data-video-modal-close]').forEach(function (el) {
    el.addEventListener('click', closeVideoModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && videoModal && !videoModal.hidden) closeVideoModal();
  });

  // Smooth-scroll for on-page anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
